/**
 * OrbDocDownloadsSkillsAROrbDocDownloadsSkillsARPage
 *
 * Page component for OrbDocDownloadsSkillsAROrbDocDownloadsSkillsARPage
 * Path: /ar/docs/downloads/skills
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { OrbDocDownloadsSkillsARDocScreenView as __OrbDocDownloadsSkillsARDocScreenView } from '@/components/traits/OrbDocDownloadsSkillsARDocScreenView';
import { OrbDocDownloadsSkillsARDocAnalyticsView as __OrbDocDownloadsSkillsARDocAnalyticsView } from '@/components/traits/OrbDocDownloadsSkillsARDocAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { usePageHead } from '@almadar/ui/hooks';

interface OrbDocDownloadsSkillsAROrbDocDownloadsSkillsARPageProps {
  // Add any page-level props here
}

export function OrbDocDownloadsSkillsAROrbDocDownloadsSkillsARPage(_props: OrbDocDownloadsSkillsAROrbDocDownloadsSkillsARPageProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":"مهارات الوكلاء","description":"علّم أي وكيل برمجي كتابة .lolo صحيحة، بالكتالوج والفحوص نفسها التي يستخدمها المترجم.","access":"public","indexing":"index","origin":"https://orb.almadar.io","siteName":"Orb","alternates":[{"locale":"en","path":"/docs/downloads/skills"},{"locale":"ar","path":"/ar/docs/downloads/skills"},{"locale":"sl","path":"/sl/docs/downloads/skills"}],"defaultLocale":"en", path: __location.pathname });

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__OrbDocDownloadsSkillsARDocScreenView config={{ initPayload: __navState }} />
          <__OrbDocDownloadsSkillsARDocAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default OrbDocDownloadsSkillsAROrbDocDownloadsSkillsARPage;
